module.exports = __webpack_public_path__ + "static/media/transfer_a_person_map.73c3288e.svg";